'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const RadioWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CustomRadio = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${Spacers.LG}rem;
  height: ${Spacers.LG}rem;
  background-image: url('/assets/icons/RadioUnchecked.svg');
`;

export const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  position: absolute;
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0;
  border: 0;
  height: 1px;
  width: 1px;
  overflow: hidden;
  cursor: pointer;

  &:focus-visible + ${CustomRadio} {
    outline: 2px solid rgb(0, 100, 214);
    outline-offset: 2px;
    border-radius: 50%;
  }

  &:checked + ${CustomRadio} {
    background-image: url('/assets/icons/RadioChecked.svg');
  }

  &:not(:checked):hover + ${CustomRadio} {
    background-image: url('/assets/icons/RadioHover.svg');
  }
`;
